<template>
    <div>
        <div class="form-control">
            <label for="cf_banco">Possui conta no Itaú?</label>
            <select name="cf_banco" id="cf_banco" required="true" v-model="dadosBancarios.banco">
                <option value="" selected>Selecione uma opção</option>
                <option value="sim">Sim</option>
                <option value="nao">Não</option>
            </select>
        </div>
        <div class="form-control" v-show="dadosBancarios.banco == 'sim'">
            <label for="cf_numero_da_agencia">Número da agência:</label>
            <input id="cf_numero_da_agencia" name="cf_numero_da_agencia" v-mask="['####', '#####', '######']" :required="dadosBancarios.banco == 'sim'">
        </div>
        <div class="form-control" v-show="dadosBancarios.banco == 'sim'">
            <label for="cf_numero_da_conta">Número da conta:</label>
            <input id="cf_numero_da_conta" name="cf_numero_da_conta"
                v-mask="['###-#', '####-#', '#####-#', '######-#']" :required="dadosBancarios.banco == 'sim'">
        </div>
        <div class="form-control" v-show="dadosBancarios.banco == 'nao'">
            <label for="cf_conta_salario">Necessita de carta para abertura de conta salário?</label>
            <select name="cf_conta_salario" id="cf_conta_salario" :required="dadosBancarios.banco == 'nao'" v-model="dadosBancarios.conta_salario">
               <option value="" selected>Selecione uma opção</option>
                <option value="sim">Sim</option>
                <option value="nao">Não</option>
            </select>
        </div>
        <div class="form-control" v-show="dadosBancarios.banco == 'sim'">
            <label for="cf_tipo_de_conta">Tipo de conta:</label>
            <select name="cf_tipo_de_conta" id="cf_tipo_de_conta" :required="dadosBancarios.banco == 'sim'">
                <option value="" selected>Selecione uma opção</option>
                <option value="corrente">Corrente</option>
                <option value="poupanca">Poupança</option>
                <option value="salario">Salário</option>
            </select>
        </div>
    </div>
</template>
<script>
import { mask } from 'vue-the-mask'

export default {
    props: {
    dadosBancarios: Object,
  },
  directives: { mask }
}

</script>